<div class="content-wrapper" id="bannerClose">
    <div class="page-header">
        <h4 class="page-titles">
            <span class="page-title-icons bg-gradient-primary text-white mr-2">
                <i class="mdi mdi-file-document"></i>
            </span> รายงานการประชุม
        </h4>
    </div>

    <div class="row">
        <div class="col grid-margin" *ngIf="page_view == false">
            <div class="card">
                <div class="row card-body  text-center">
                    <div class="table-responsive" style="min-height: 50vh;">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col" style="font-weight: 500;">ครั้งที่</th>
                                    <th scope="col" style="font-weight: 500;">ชื่อการประชุม</th>
                                    <th scope="col" style="font-weight: 500;">วันที่ประชุม</th>
                                    <th scope="col" style="font-weight: 500;">เวลา</th>
                                    <th scope="col" style="font-weight: 500;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of list_report| paginate : {
                                    itemsPerPage: tableSize,
                                    currentPage: page,
                                    totalItems: count
                                  };">
                                    <td>{{item.rpm_session}}</td>
                                    <td class="text-left">{{item.rpm_name}}</td>
                                    <td>{{item.date}}</td>
                                    <td>{{item.time}}</td>
                                    <td>
                                        
                                        <a (click)="onClick(item)" type="button" class="btn btn-inverse-success btn-sm" style="margin-right: 10px;"
                                        data-toggle="modal" data-target="#reportMeeting_update"><i class="mdi mdi-border-color" style="font-size: 12px;"></i></a>

                                        <a href="https://ogc.mapedia.co.th/api/v1/lrfund/report_committee/{{ item.pdf_name }}" type="button" class="btn btn-inverse-primary btn-sm" target="_blank" ><i class="mdi mdi-file-document" style="font-size: 12px;"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br>
                        <pagination-controls previousLabel="ก่อนหน้า" nextLabel="ถัดไป" class="my-pagination"
                            (pageChange)="onTableDataChange($event)" style="text-align: center;">
                        </pagination-controls>
                        <h3 *ngIf="list_report.length == 0 " style="color: #ebedf2;">ไม่พบข้อมูลที่เลือก</h3>
                    </div>
                </div>
            </div>
        </div>

        <div class="col grid-margin" *ngIf="page_view == true">
            <div class="card">

                <div class="row  card-body">
                    <div class="col-9 text-left" style="cursor:context-menu;">
                        <h3> {{pdf_detail.rpm_name}} </h3>
                        <h4 class="font-weight-light">ครั้งที่ : {{pdf_detail.rpm_session}} </h4>
                        <h4 class="font-weight-light"> วันที่ประชุม : {{pdf_detail.date}} เวลา : {{pdf_detail.time}}
                        </h4>
                    </div>
                    <div class="col-3 text-right"><button type="button" class="btn btn-outline-primary"
                            (click)="close_pdf()">ย้อนกลับ</button></div>
                </div>
                <div class="row card-body text-center">
                    <div class="col">

                        <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;">
                        </pdf-viewer>

                    </div>
                </div>
            </div>
        </div>


    </div>
</div>

<div class="modal fade" id="reportMeeting_update" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel-2">แก้ไขรายงานการประชุม
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form class="forms-sample" [formGroup]="reportM_form" *ngIf="reportM_form">
                    <div class="form-group">
                        <label>ครั้งที่</label>
                        <input type="text" class="form-control" formControlName="rpm_session" name="rpm_session" autocomplete="off">
                    </div>
                    <div class="form-group">
                        <label>ชื่อการประชุม</label>
                        <input type="text" class="form-control" formControlName="rpm_name" name="rpm_name" autocomplete="off">
                    </div>
                    <div class="form-group">
                        <label>วันที่ประชุม</label>
                        <input type="date" class="form-control" formControlName="date" name="date" autocomplete="off">
                    </div>
                    <div class="form-group">
                        <label>เวลา</label>
                        <input type="text" class="form-control" formControlName="time" name="time" autocomplete="off">
                    </div>
                </form>
                <div class="text-center">
                    <button type="submit" class="btn btn-gradient-primary mr-2" (click)="onUpdate()" [disabled]="!reportM_form.valid">บันทึกการแก้ไข</button>
                    <button class="btn btn-light" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>